module.exports = ['$scope', '$rootScope', 'config', '$modalInstance', 'CalendarNoteSvc', 'ModalSvc', function ($scope, $rootScope, config, $modalInstance, CalendarNoteSvc, ModalSvc) {
    'use strict';

    function handleSuccess(note) {
        $modalInstance.close(note);
    }

    function handleError(errors) {
        $scope.error = errors;
    }

    $scope.cancel = function () {
        $modalInstance.dismiss();
    };

    $scope.$watch("note.type", function (newType, oldType) {

        if (angular.isUndefined(oldType)) return;

        switch (newType) {
            case "plant_closure":
                $scope.note.title = "Plant Closure";
                $scope.note.icon = "ban-circle";
                break;
            case "inspection":
                $scope.note.title = "Inspection";
                $scope.note.icon = "wrench";
                break;
            case "custom":
                $scope.note.title = "";
                $scope.note.icon = "";
                break;
            default:
                break;
        }
    });

    $scope.save = function () {

        $scope.note.calendar_type = "order_calendar";

        var method;

        switch ($scope.mode) {
            case "edit":
                method = "update";
                break;
            case "create":
                method = "create";
                break;
            default:
                break;
        }

        CalendarNoteSvc[method]($scope.note, $rootScope.plant).success(handleSuccess).error(handleError);
    };

    $scope.addDate = function() {
        function getNextWeekday(currentDay) {
          var nextDate = "";

          if (currentDay != "") {
            var lastDate = moment(currentDay, $scope.$root.dateFormat.moment);
            if (lastDate.day() == 5) {
              lastDate.add(3, "days");
            } else {
              lastDate.add(1, "days");
            }

            nextDate = lastDate.format($scope.$root.dateFormat.moment);
          }
          return nextDate;
        }

        var lastDate = $scope.note.dates[$scope.note.dates.length - 1];
        $scope.note.dates.push({
          date: getNextWeekday(lastDate.date)
        })
    };

    $scope.removeDate = function(index) {
        $scope.note.dates.splice(index, 1);
    };

    $scope.deleteCalendarNote = function (note) {
        var modal = ModalSvc.confirmationDialog.open({
            title: `Delete note`,
            message: `Are you sure you want to delete ${note.title}?`
        });

        $scope.deleteModalOpened = true;

        modal.result.then(function (result) {
            CalendarNoteSvc.delete(note.id, $rootScope.plant).success(function () {
                $modalInstance.close(note);
            }).error(handleError);
        }, function () {
            $scope.deleteModalOpened = false;
        });
    };

    $scope.selectIcon = function (icon) {
        if ($scope.note.icon == icon.name) {
            $scope.note.icon = "";
        }
        else {
            $scope.note.icon = icon.name;
        }
    };

    function init() {
        $scope.mode = angular.isDefined(config.note_id) ? "edit" : "create";

        $scope.noteTypes = [
            {label: "Plant closure", value: "plant_closure"},
            {label: "Inspection", value: "inspection"},
            {label: "Custom", value: "custom"}
        ];

        if ($scope.mode == "create") {
            $scope.note = {
                type: $scope.noteTypes[0].value,
                dates: [{
                    date: config.on_date,
                }],
            };
        }

        if ($scope.mode == "edit") {
            CalendarNoteSvc.get(config.note_id, $rootScope.plant).success(function (note) {
                $scope.note = note;
            });
        }
    }

    init();

}];

